
import { Component, Vue, Prop } from 'vue-property-decorator';
import SvgMonday from '@/assets/icons/nav-bar/monday.svg';
import SvgBrandmark from '@/assets/icons/nav-bar/brandmark.svg';
import SvgGoogleDrive from '@/assets/icons/nav-bar/google-drive.svg';
import store from '@/store';

@Component({
    components: {
        SvgMonday,
        SvgBrandmark,
        SvgGoogleDrive,
    },
})
export default class QuickLinks extends Vue {
    @Prop({ type: Boolean, default: true }) mini!: boolean;

    get usersRole(): string[] {
        return store.getters['authModule/GET_USER'].roles;
    }

    links = [
        {
            title: 'Руководства',
            href: 'https://drive.google.com/drive/u/0/folders/0AMxrooQ5MAcHUk9PVA',
            icon: SvgGoogleDrive,
            show: true,
            style: {
                width: '33px',
                height: '33px',
            },
        },
        {
            title: 'Monday',
            modal: true,
            menu: false,
            icon: SvgMonday,
            links: [
                {
                    title: 'Запрос выплаты',
                    href: 'https://leadgidwebvork.monday.com/boards/666732634/views/11071624',
                },
                {
                    title: 'Отклонение / правка цен',
                    href: 'https://leadgidwebvork.monday.com/boards/658485653',
                },
            ],
            show : true,
        },
        {
            title: 'Stata',
            href: 'https://stata.leadgid.ru/',
            icon: SvgBrandmark,
            show : this.usersRole.includes('ROLE_ADMIN') || this.usersRole.includes('ROLE_STAT_MANAGER'),
        },
    ];
}
